enum ClientStatusSortableColumns {
  ClientName = 'ClientName',
  DateOfEntry = 'DateOfEntry',
  DateOfRelease = 'DateOfRelease',
}

export default ClientStatusSortableColumns;
